import { useEffect, useState } from 'react';
import { debounce } from 'lodash-es';
import { fetchSelectOptions } from '../../helpers/formHelpers';

export const useSelectOptions = (fetchConfig, debounceTime) => {
  const [optionsData, setOptionsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchOptions = async () => {
    setIsLoading(true);
    try {
      if (fetchConfig?.endPoint) {
        const result = await fetchSelectOptions(fetchConfig);
        // result has to be a array of objects
        if (Array.isArray(result)) {
          setOptionsData(result);
        }
      }
    } catch (error) {
      console.error('Error fetching options:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchConfig]);

  const debouncedHandleInputChange = debounce(async (inputText, meta) => {
    if (meta.action !== 'input-blur' && meta.action !== 'menu-close') {
      const newEndpoint = `${fetchConfig?.endPoint}${inputText}`;
      const updatedFetchConfig = {
        ...fetchConfig,
        endPoint: newEndpoint,
      };
      setIsLoading(true);

      try {
        const res = await fetchSelectOptions(updatedFetchConfig);
        if (Array.isArray(res)) {
          setOptionsData(res);
        }
      } catch (error) {
        console.error('Error fetching options:', error);
      } finally {
        setIsLoading(false);
      }
    }
  }, debounceTime);

  return { optionsData, isLoading, debouncedHandleInputChange };
};
